<template>
    <div class="content">
        <div class="content_wrap">
            <h2 class="content_title">의견쓰기</h2>
            <div class="opinion_wrap">
                <h3><i class="fas fa-edit"></i>학습자님의 의견을 자유롭게 적어주세요.</h3>
                <textarea v-model="opinion" cols="30" rows="10">
                </textarea>
                <div class="btnwrap">
                    <button @click="sendOpinion" type="button" class="submitbt main">저장</button>
                </div>
            </div>
        </div>        
        <embed v-if="contents.currentSlide.bgm != undefined" :src="'../assets/media/' + contents.currentSlide.bgm" autostart="true" loop="false" width="280" height="45" hidden="true">
    </div>
</template>
<script>
export default {
    props : ['contents'],
    data(){
        return{
            opinion : ''
        }
    },
    methods:{
        sendOpinion(){
            if(typeof settings.sendOpinion !== 'undefined' && settings.sendOpinion != null){
                return  settings.sendOpinion(this.contents.chapterId,this.opinion);
            }
            if(this.opinion.length < 10){
                swal("알림","최소 10자 이상으로 적어주세요.",'info');
            }else{
                swal("알림","성공적으로 저장되었습니다.",'success');
            }
        }
    },
    mounted(){
    }
}
</script>